import { ApiActionResponse } from "../../core/action-types";

export enum AIActionType {
  NEW_CHAT = "ai/new-chat",
}

export interface Source {
  cfi: string;
  index: number;
  htmlPath: string;
}

export interface Flashcard {
  front: string;
  back: string;
}

export interface AIEvent {
  id: string;
  session_id: string;
  trace_id: string;
  type: "event" | "score";
  name:
    | "thumbs"
    | "click-definition"
    | "create-flashcards"
    | "click-link"
    | "copy"
    | "speak";
  value: number;
  comment?: string;
}

export interface Interaction {
  text: string;
  sources: Source[];
}

export interface AnswerResponse {
  chatId: string;
  messageId: string;
  type: "user-response";
  interaction: Interaction[];
  possible_responses?: string[];
  possible_responses_header?: string;
  data: {
    flashcards?: Flashcard[];
  };
  images: { path: string; cfi: string; index: number }[];
  definitions?: { [key: string]: string };
  metadata: {
    lull: boolean;
  };
}

export interface ChatLogEntry {
  supernovaId: string;
  question: string;
  answer?: AnswerResponse;
  score?: AIEvent;
  hasError?: boolean;
}

export type TranslationResponse = ApiActionResponse<{
  translatedText: string;
  sourceLanguage: string;
  targetLanguage: string;
}>;
